import styled from "styled-components";
import figma from "../../../assets/figma_landingpage.png";
import FigmaTechIcons from "../figmaProject/FigmaTechIcons";
import FigmaDescription from "./FigmaDescription";
import ProjectBtns from "../ProjectBtns";

export default function Twitter() {
  return (
    <ProjectContainer>
      <ProjectDesc>
        <h2>Landing Page with Figma, Tailwind & NextJs</h2>
        <p>
          The purpose of this project was to learn how to work with Figma and
          Tailwind CSS. I used free designed{" "}
          <Link
            target="_blank"
            href="https://www.figma.com/design/mVjpT84IChxhDcLq8Y0nDQ/Free-Landing-Page%2C-Desktop-%2B-Mobile---VC-(Community)?node-id=1-828"
          >
            landing page from Figma
          </Link>
          .{` `}The application features a fully responsive design, ensuring
          that both the layout and images adapt seamlessly to different screen
          sizes and devices. I also incorporated additional animations to
          enhance the user experience
        </p>
        <div>
          <Features>Used technologies:</Features>
          <FigmaTechIcons />
        </div>
        <div>
          <Features>Features/Description:</Features>
          <FigmaDescription />
        </div>
      </ProjectDesc>
      <ProjectBtns>
        <button>
          <a
            href="https://landingpage-figma-nextjs-tailwind.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Try it live
          </a>
        </button>
        <button>
          <a
            href="https://github.com/Kamildeeal/landing-page-figma-nextjs-tailwind"
            target="_blank"
            rel="noopener noreferrer"
          >
            View source
          </a>
        </button>
      </ProjectBtns>
      <Overview>
        <h2>Hover to see overview</h2>
        <div>
          <ProjectImageWrapper>
            <ProjectImage src={figma} alt="figma_teaser" />
          </ProjectImageWrapper>
        </div>
      </Overview>
    </ProjectContainer>
  );
}

const ProjectDesc = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  & > h2 {
    color: rgba(237, 246, 79, 0.8);
  }

  & > p {
    margin-bottom: 20px;
  }

  & > h2,
  div {
    margin-bottom: 20px;

    @media (max-width: 460px) {
      margin-bottom: 10px;
    }
  }
`;

const ProjectContainer = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  margin-top: 30px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  overflow: hidden;
  color: white;
  padding: 10px 20px;
  margin-bottom: 80px;
  transition: all 0.1s ease;

  &:hover {
    background: rgba(36, 36, 41, 0.87);
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
  }
  @media (max-width: 460px) {
    margin-bottom: 16px;
  }
`;

const ProjectImageWrapper = styled.div`
  position: relative;
  width: 500px;
  height: 400px;
  overflow: hidden;
  border-radius: 8px;
  border: 2px solid black;

  &:hover img {
    transform: translateY(-68%);
  }
`;
const Link = styled.a`
  color: white;
  font-weight: bolder;
`;

const ProjectImage = styled.img`
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  transition: transform 3s ease-in-out;
`;
const Overview = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;

  > h2 {
    margin-bottom: 10px;
  }

  @media (max-width: 1024px) {
    align-items: center;
    justify-content: center;
    r > h2 {
      justify-content: center;
    }
  }
  @media (max-width: 670px) {
    display: none;
  }
`;

const Features = styled.div`
  color: rgba(237, 246, 79, 0.8);
  font-weight: bold;
  margin-bottom: 0 !important;
  padding: 0;
`;
